import { MaterialType } from "../types/material.type";
import { CompanyAddressResponse, CompanyResponse } from "../types/company.type";

export const getCompanyLegalAddressLabel = (
  company?: CompanyResponse | null
): string | null => {
  if (!company) return null;

  const legal = company.addresses?.find(
    (a: CompanyAddressResponse) => a.isLegalAddress
  );
  const address = legal || company.addresses?.[0];

  const countryName = address?.country?.name || company.country?.name;
  const state = address?.state;

  const label = [state, countryName].filter(Boolean).join(", ");
  return label || null;
};

/**
 * Where an order is delivered, or for a service where it is performed (SCRUM-55): the picked
 * site's address, else the free text the buyer typed when no site fits.
 */
export const orderPlace = (order?: {
  deliveryPlace?: { address?: string } | null;
  address?: string | null;
}): string | undefined =>
  order?.deliveryPlace?.address || order?.address || undefined;

/** The label for that place: a service is performed somewhere, goods are delivered. */
export const orderPlaceLabelKey = (order?: {
  material?: { category?: { type?: string } | null } | null;
}): string =>
  order?.material?.category?.type === MaterialType.SERVICES
    ? "tenders.form.servicePlace"
    : "offer.buyerDeliveryPlace";
